@if (isProfileMenuOpen()) {
<div class="profile-menu-overlay" (click)="isProfileMenuOpen.set(false)" role="button" tabindex="0" (keydown.enter)="isProfileMenuOpen.set(false)" (keydown.space)="$event.preventDefault(); isProfileMenuOpen.set(false)"> <!-- NOSONAR: click-outside-to-dismiss backdrop; wraps role=dialog content, cannot become a native button -->
  <div class="profile-menu" role="menu" aria-label="Profile menu" (click)="stopProp($event)" (keydown.enter)="stopProp($event)" (keydown.space)="$event.preventDefault(); stopProp($event)">
    <div class="profile-menu-head">
      <div class="profile-menu-head-avatar" aria-hidden="true">{{ profile().initials }}</div>
      <div class="profile-menu-head-details">
        <div class="profile-menu-head-topline">
          <div class="profile-menu-name">{{ profile().name || 'Signed in' }}</div>
          @if (profile().role) {
          <div class="profile-menu-role">{{ profile().role }}</div>
          }
        </div>
        <div class="profile-menu-email">{{ profile().email || '—' }}</div>
      </div>
    </div>

    <div class="profile-menu-divider" aria-hidden="true"></div>

    <button type="button" class="profile-menu-item" role="menuitem" (click)="goToProfilePage()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
      <span>My Profile</span>
    </button>

    <div class="profile-menu-divider" aria-hidden="true"></div>

    <button type="button" class="profile-menu-item profile-menu-item--danger" role="menuitem"
      (click)="signOut()" [disabled]="signingOut()" [attr.aria-disabled]="signingOut()">
      @if (signingOut()) {
      <span class="profile-menu-item-spinner" aria-hidden="true"></span>
      } @else {
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
        <polyline points="16 17 21 12 16 7"></polyline>
        <line x1="21" y1="12" x2="9" y2="12"></line>
      </svg>
      }
      <span>{{ signingOut() ? 'Signing out…' : 'Sign Out' }}</span>
    </button>
  </div>
</div>
}
